import React from 'react';
import { Link } from 'react-router-dom';
import EmptyIcon from '../../Assets/Mixed/EmptyIcon';

import './EmptyTable.css';
import { useTranslation } from 'react-i18next';

export default (props) => {
  /*eslint no-extend-native: ["error", { "exceptions": ["String"] }]*/
  String.prototype.beginsWith = function (string) {
    return this.indexOf(string) === 0;
  };

  const { t } = useTranslation();
  let filter = t('common.filter.no_data');
  let start_message = false;

  if (props.inModal) {
    filter = t('common.filter.no_data');
  } else if (window.location.pathname.includes('contacts')) {
    if (window.location.search.includes('?filter=vendor')) {
      filter = t('common.filter.no_vendor_contact');
    } else if (window.location.search.includes('?filter=customer')) {
      filter = t('common.filter.no_customer_contact');
    } else if (window.location.search.includes('?filter=active')) {
      filter = t('common.filter.no_active_contact');
    } else if (window.location.search.includes('?filter=inactive')) {
      filter = t('common.filter.no_inactive_contact');
    }
  } else if (window.location.search.includes('&start=')) {
    filter = t('common.filter.no_filter_data');
    start_message = true;
  } else if (window.location.pathname.startsWith('/items')) {
    filter = t('common.filter.no_matched_item');
  } else if (window.location.pathname.startsWith('/salesorders')) {
    filter = t('common.filter.no_matched_sales_order');
  } else if (window.location.pathname.startsWith('/packages')) {
    filter = t('common.filter.no_matched_package');
  } else if (window.location.pathname.startsWith('/invoices')) {
    filter = t('common.filter.no_matched_invoice');
  } else if (window.location.pathname.startsWith('/salesreturns')) {
    filter = t('common.filter.no_matched_sales_return');
  } else if (window.location.pathname.startsWith('/creditnotes')) {
    filter = t('common.filter.no_matched_credit_notes');
  } else if (window.location.pathname.startsWith('/deliverymethods')) {
    filter = t('common.filter.no_delivery_method');
  } else if (window.location.pathname.startsWith('/taxes')) {
    filter = t('common.filter.no_tax');
  } else if (window.location.pathname.startsWith('/warehouses')) {
    filter = t('common.filter.no_warehouses');
  } else if (window.location.pathname.startsWith('/currencies')) {
    filter = t('common.filter.no_currency');
  }
  return (
    <div className="empty-table">
      <EmptyIcon />
      {!start_message && (
        <h5>
          {t('common.there_is')} {filter} {t('common.available')}.
        </h5>
      )}
      {start_message && <h5>{filter}</h5>}
      {start_message && (
        <Link to="/dashboard">
          <h5 className="text_underline pointer">
            {t('common.go_to_dashboard')}
          </h5>
        </Link>
      )}
    </div>
  );
};
